/**
 * Set cookie on browser
 * @param {String} cname name of cookie
 * @param {*} cvalue value of cookie
 * @param {Number} exdays days until cookie expires
 */
export const setCookie = (cname, cvalue, exdays) => {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

/**
 * Get cookie from browser
 * @param {String} cname name of cookie
 */
export const getCookie = cname => {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (let i = 0, length = ca.length; i < length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

/**
 * Remove cookie from browser
 * @param {String} cname name of cookie
 */
export const removeCookie = (cname) => {
    document.cookie = cname + '=; Path=/; Max-Age=-99999999;'
}
